export default class readConfirmCtrl {
    constructor($scope, $uibModalInstance, applyRecord) {
        $scope.applyRecord = applyRecord
        $scope.cancel = function cancel() {
            $uibModalInstance.dismiss()
        }

        $scope.ok = function ok() {
            $uibModalInstance.close(true)
        }
    }
}
readConfirmCtrl.$inject = ['$scope', '$uibModalInstance', 'applyRecord']



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/application/readConfirmCtrl.js